export const API_DOMAIN_DEV = "https://api-usa-test.gouspa.org/application/api";
export const API_DOMAIN_PROD = "https://api-usa1.gouspa.org/application/api";

const LOCAL_DOMAINS = ["localhost"];
const DOMAINS_DEV = ["application-test.gouspa.org"];
const DOMAINS_PROD = ["application.gouspa.org"];

const host = window.location.hostname.toLowerCase();

export const isLocal = LOCAL_DOMAINS.find((domain) => host === domain);
export const isDevelopment = DOMAINS_DEV.find((domain) => host === domain);
export const isProduction = DOMAINS_PROD.find((domain) => host === domain);

export const getApiDomain = (useDevelopment) => {
    if (isLocal || useDevelopment) return API_DOMAIN_DEV;

    if (isDevelopment) return API_DOMAIN_DEV;
    if (isProduction) return API_DOMAIN_PROD;

    return "";
};
